"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormHandlerEvent = void 0;
var FormHandlerEvent;
(function (FormHandlerEvent) {
    FormHandlerEvent["VALIDATING"] = "validating";
    FormHandlerEvent["VALIDATION_FAIL"] = "validation fails";
    FormHandlerEvent["SUBMITTING"] = "submitting";
    FormHandlerEvent["SUBMITTED"] = "submitted";
    FormHandlerEvent["ERROR"] = "error";
    FormHandlerEvent["INITIALIZED"] = "initialized";
})(FormHandlerEvent = exports.FormHandlerEvent || (exports.FormHandlerEvent = {}));
